<template>
  <div class="main">
    <div class="content">
      <div v-if="show" class="loading-container">
        <div v-if="!error" id="loading-wrapper">
          <div id="loading-text">LADE...</div>
          <div id="loading-content"></div>
        </div>
        <div v-else>
          <img
            class="error404"
            src="@/assets/beer-mug-empty.svg"
            alt="empty"
            height="87"
            width="100"
          />
          <p class="empty">Such emptiness...</p>
        </div>
      </div>
      <div v-else class="bg-color">
        <div class="card-wrapper">
          <div class="card">
            <div class="user">
              <div class="user__name">{{ user.name + ' ' + user.surname }}</div>
              <div class="user__title">{{ user.title }}</div>
              <div class="user__sports">{{ user.sports }}</div>
            </div>
            <img class="userImage" :src="user.bytes" />
            <ul class="userdata">
              <li class="userdata__birthday">{{ user.birthday }}</li>
              <li class="userdata__home">{{ user.home }}</li>
              <li class="userdata__section">{{ user.section }}</li>
            </ul>
            <div class="userId">ID: {{ user.cardId }}</div>
          </div>
        </div>
        <div class="footer-wrapper">
          <div class="sports-brand">Wettkampfklettern Spitzensport</div>
          <div class="footer">
            <img class="footer__logo" src="@/assets/footer-logo.png" />
            <p class="footer__brand">DAV</p>
            <div class="text-wraper">
              <div class="footer__text--line1">
                DEUTSCHER ALPENVEREIN
              </div>
              <div class="footer__text--line2">
                LANDESVERBAND NRW
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';

export default {
  name: 'Card',
  title: 'Kaderausweis',
  components: {},

  data() {
    return {
      user: '',
      res: '',
      error: '',
    };
  },
  async created() {
    const getUser = firebase.functions().httpsCallable('getUserByHash');
    const userHash = this.$route.params.user;
    const res = await getUser({
      hash: userHash,
    });
    this.user = res.data;
    if (res.data === false) {
      this.error = 'this aint working';
    }
  },
  computed: {
    show: function() {
      this.user;
      this.error;
      return !this.user || this.error;
    },
  },
};
</script>

<style lang="scss">
#app {
  height: 100%;
}

html {
  height: 100%;
}

body {
  height: 100%;
}
</style>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
}

.main {
  background-color: #7dc355;
  z-index: -2;
  height: 100%;
}

.content {
  display: flex;
  display: -webkit-flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%;
  z-index: -1;
}

/** Error Image and Text 404 */
.error404 {
  display: block;
  margin: auto;
  margin-left: auto;
  margin-right: auto;
}

.empty {
  font-size: 18px;
  margin-top: 30px;
  font-weight: 800;
  color: white;
}

.card-wrapper {
  height: calc(100% - 72px);
}

.card {
  text-align: center;
  z-index: 0;
  position: relative;
}

// ##### BACKGROUND
.bg-color {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #7dc355 20%, #ffffff 50%);
}

.userImage {
  width: 170px;
  height: 170px;
  border-radius: 50%;
  display: block;
  margin: auto;
  border: 5px solid white;
  @media (min-width: 375px) {
    width: 220px;
    height: 220px;
  }

  @media (min-height: 636px) {
    margin-top: 1rem;
    margin-bottom: 1rem;
    width: 270px;
    height: 270px;
  }
}

.user {
  padding: 0.7rem 0;

  @media (min-height: 520px) {
    padding-top: 2rem;
  }

  @media (min-height: 736px) {
    padding-top: 3rem;
  }
  &__name {
    color: white;
    font-size: 26px;
    font-weight: 700;
    font-family: roboto;

    @media (min-height: 665px) {
      font-size: 2rem;
      margin-top: 1rem;
      padding-top: 1rem;
    }
  }
  &__title {
    color: black;
    font-size: 1rem;
    font-weight: 800;
    margin: 0.1rem 0px;

    text-transform: uppercase;
    @media (min-height: 567px) {
      margin: 0.3rem 0px;
    }
    @media (min-height: 667px) {
      font-size: 1.2rem;
    }
  }
  &__sports {
    color: white;
    font-size: 0.9rem;
    @media (min-height: 667px) {
      font-size: 1.3rem;
    }
  }
}

.userdata {
  list-style-type: none;
  display: inline-block;
  text-align: left;
  margin-top: 1rem;
  margin-bottom: 0.3rem;
  font-size: 17px;

  @media (min-height: 568px) {
    margin: 1rem 0;
    font-size: 17px
  }
  @media (min-height: 768px) {
    margin-top: 1rem;
    font-size: 1.3rem;
  }

  & li {
    margin-bottom: 0.3rem;
    font-weight: 500;
    @media (min-width: 375px) {
    }

    &:before {
      font-family: bullets;
      float: left;
      width: 1.4em;
      padding-right: 2rem;
      padding-top: 0.2rem;
    }
  }

  &__birthday {
    &:before {
      content: url(~@/assets/birthday-cake-solid.svg);
    }
  }
  &__home {
    &:before {
      padding-top: 3px;
      content: url(~@/assets/home-solid.svg);
    }
  }
  &__section {
    &:before {
      padding-top: 5px;
      content: url(~@/assets/tags-solid.svg);
    }
  }
}
.userId {
  margin-bottom: 2rem;
  color: grey;
}

.footer-wrapper {
  width: 100%;
  position: fixed;
  bottom: 0;
  color: #ffffff;
}
.sports-brand {
  color: #2b2a2a;
  text-align: center;
  font-size: 12.5px;
  text-transform: uppercase;
  font-weight: 600;
  text-align: center;
  z-index: 2;
  @media (min-width: 335px) {
    font-size: 15.5px;
  }
}
.footer {
  background: #2b2a2a;
  position: relative;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: 375px) {
    height: 50px;
  }

  &__logo {
    height: 35px;
    padding-left: 5px;
  }

  &__brand {
    color: white;
    font-family: Roboto;
    padding-left: 10px;
    font-size: 32px;
    font-weight: 700;
    padding-right: 10px;
    transform: scaleY(1.1);
  }

  &__text {
    &--line1 {
      color: white;
      text-align: left;
      padding-left: 0px;
      font-weight: 500;
      font-size: 12px;
    }
    &--line2 {
      color: white;
      text-align: left;
      padding-left: 0px;
      font-weight: 900;
      font-size: 12px;
    }
  }
}

// ##########   START loading spinner

.loading-container {
  height: 100vh;
  display: flex;
  align-items: center;
}

#loading-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

#loading-text {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  color: #ffffff;
  width: 100px;
  height: 30px;
  margin: -7px 0 0 -45px;
  text-align: center;
  font-family: 'PT Sans Narrow', sans-serif;
  font-size: 20px;
}

#loading-content {
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  width: 170px;
  height: 170px;
  margin: -85px 0 0 -85px;
  border: 3px solid #ffffff;
}

#loading-content:after {
  content: '';
  position: absolute;
  border: 3px solid #ffffff;
  left: 15px;
  right: 15px;
  top: 15px;
  bottom: 15px;
}

#loading-content:before {
  content: '';
  position: absolute;
  border: 3px solid #ffffff;
  left: 5px;
  right: 5px;
  top: 5px;
  bottom: 5px;
}

#loading-content {
  border: 3px solid transparent;
  border-top-color: #ffffff;
  border-bottom-color: #ffffff;
  border-radius: 50%;
  -webkit-animation: loader 2s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 2s linear infinite;
}

#loading-content:before {
  border: 3px solid transparent;
  border-top-color: #ffffff;
  border-bottom-color: #ffffff;
  border-radius: 50%;
  -webkit-animation: loader 3s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 3s linear infinite;
}

#loading-content:after {
  border: 3px solid transparent;
  border-top-color: #ffffff;
  border-bottom-color: #ffffff;
  border-radius: 50%;
  -webkit-animation: loader 1.5s linear infinite;
  animation: loader 1.5s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
}

@-webkit-keyframes loaders {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loader {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

// ##########   END loading spinner
</style>
